import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';

@Pipe({
  name: 'distanceToBottomDisplay'
})
export class DistanceToBottomDisplayPipe implements PipeTransform {
  transform(cm: number, text: string): string {
    return cm != null
      ? `${cm} cm tot onderkant bord`
      : StringHelper.isEmpty(text)
      ? 'Aangepaste afstand tot onderkant bord'
      : text;
  }
}
